window.addEventListener('load', function () {
    const checkbox = document.querySelector('input[type="checkbox"][name="dual_pricing_enabled"]');
    if (!checkbox) return;

    const ppdLabel = document.getElementById('ppd-label');
    const fobSection = document.getElementById('fob-section');
    const warning = document.getElementById('dual-pricing-parent-warning');

    checkbox.addEventListener('change', function () {
        if (ppdLabel) ppdLabel.classList.toggle('hidden', !this.checked);
        if (fobSection) fobSection.classList.toggle('hidden', !this.checked);
        if (warning) warning.classList.toggle('hidden', !this.checked);
    });
});
